import { required, between, minValue, maxValue, minLength, maxLength, numeric } from '@vuelidate/validators';
import FIMenuLeaseTerm from './FIMenuLeaseTerm';
import FIMenu from './FIMenu';

export interface IFIMenuLeaseTerms {
	acceptedTerm?: any;
	firstpayment?: any;
	finalMonthlyPayment?: any;
	term1?: FIMenuLeaseTerm;
	term2?: FIMenuLeaseTerm;
	term3?: FIMenuLeaseTerm;
}

export default class FIMenuLeaseTerms implements IFIMenuLeaseTerms {
	acceptedTerm?: any = null;
	firstpayment?: any = null;
	finalMonthlyPayment?: any = null;
	term1?: FIMenuLeaseTerm = new FIMenuLeaseTerm();
	term2?: FIMenuLeaseTerm = new FIMenuLeaseTerm();
	term3?: FIMenuLeaseTerm = new FIMenuLeaseTerm();

	static validationTypes = {
		TERMS: 'TERMS',
		DEFAULT: 'DEFAULT',
	};

	constructor(init?: IFIMenuLeaseTerms) {
		if (init) {
			this.acceptedTerm = init?.acceptedTerm;
			this.firstpayment = init?.firstpayment;
			this.finalMonthlyPayment = init?.finalMonthlyPayment;
			this.term1 = new FIMenuLeaseTerm(init?.term1);
			this.term2 = new FIMenuLeaseTerm(init?.term2);
			this.term3 = new FIMenuLeaseTerm(init?.term3);
		}
	}

	getAcceptedTerm() {
		if (this.acceptedTerm) {
			if (this.acceptedTerm === 1 && this.term1) return this.term1;
			if (this.acceptedTerm === 2 && this.term2) return this.term2;
			if (this.acceptedTerm === 3 && this.term3) return this.term3;
			return null;
		} else return null;
	}

	availableTerms() {
		return [this.term1, this.term2, this.term3].filter(term => term.isAvailable());
	}

	allTerms() {
		return [this.term1, this.term2, this.term3];
	}

	validation(fimenu: FIMenu, type: string = FIMenuLeaseTerms.validationTypes.DEFAULT) {
		const data = {
			finalMonthlyPayment: {},
			term1: {
				term: {},
				residual: {},
				moneyfactor: {},
				buyrate: {},
			},
			term2: {
				term: {},
				residual: {},
				moneyfactor: {},
				buyrate: {},
			},
			term3: {
				term: {},
				residual: {},
				moneyfactor: {},
				buyrate: {},
			},
		};

		switch (type) {
			case FIMenuLeaseTerms.validationTypes.DEFAULT:
				return data;
			case FIMenuLeaseTerms.validationTypes.TERMS:
				if (fimenu.isLease()) {
					const t1BuyRateMax = fimenu.leaseTerms.term1.sellrate ?? 0;
					const t2BuyRateMax = fimenu.leaseTerms.term2.sellrate ?? 0;
					const t3BuyRateMax = fimenu.leaseTerms.term3.sellrate ?? 0;

					let residualMin = fimenu.lender.lenderCode === 'DA' ? 0 : 10;

					data.term1 = {
						term: { required, minValue: minValue(1) },
						residual: {
							required,
							minValue: minValue(residualMin),
							maxValue: maxValue(100),
						},
						moneyfactor: { required },
						buyrate: {
							required,
							minValue: minValue(t1BuyRateMax - 3),
							maxValue: maxValue(t1BuyRateMax),
						},
					};

					if (fimenu.leaseTerms.term2.term) {
						data.term2.residual = {
							required,
							minValue: minValue(residualMin),
							maxValue: maxValue(100),
						};
						data.term2.moneyfactor = { required };
						data.term2.buyrate = {
							required,
							minValue: minValue(t2BuyRateMax - 3),
							maxValue: maxValue(t2BuyRateMax),
						};
					}
					if (fimenu.leaseTerms.term3.term) {
						data.term3.residual = {
							required,
							minValue: minValue(residualMin),
							maxValue: maxValue(100),
						};
						data.term3.moneyfactor = { required };
						data.term3.buyrate = {
							required,
							minValue: minValue(t3BuyRateMax - 3),
							maxValue: maxValue(t3BuyRateMax),
						};
					}
				}
				return data;
			default:
				return data;
		}
	}
}
